import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-caminhos-modal',
  templateUrl: './caminhos-modal.component.html',
  styleUrls: ['./caminhos-modal.component.scss'],
  standalone: false,
})
export class CaminhosModalComponent {
  constructor(public translate: TranslateService) {
    this.windowWidth = window.innerWidth;
    this.isIphone = /iPhone/i.test(navigator.userAgent);
  }

  windowWidth: number = 0;
  isIphone = false;
  devToolsOpen: boolean = false;
  resize = false;
  public videoCaminhosPath = environment.videoCaminhosPath;

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.windowWidth = window.innerWidth;
    this.isIphone = /iPhone/i.test(navigator.userAgent);
    this.resize = true;
  }

  getImagePath(imageNumber: number): string {
    return `../../../assets/images/caminhos/png/${imageNumber}.png`;
  }

  playVideo() {
    this.videoPlayer.nativeElement.play();
  }

  pauseVideo() {
    this.videoPlayer.nativeElement.pause();
  }

  rewind() {
    this.videoPlayer.nativeElement.currentTime -= 10;
  }

  forward() {
    this.videoPlayer.nativeElement.currentTime += 10;
  }
}
